import { render, staticRenderFns } from "./oom.vue?vue&type=template&id=3ddee3d5&scoped=true"
import script from "./oom.vue?vue&type=script&lang=js"
export * from "./oom.vue?vue&type=script&lang=js"
import style0 from "./oom.vue?vue&type=style&index=0&id=3ddee3d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddee3d5",
  null
  
)

export default component.exports